module.exports = __webpack_public_path__ + "img/mobile-banner-background.a0bcb51b.jpg";